import { AuthLinkButton } from '@nicejob-library/design-system/authentication';
import { translate } from '@nicejob-library/internationalization';
import React, { ReactElement } from 'react';

/**
 * link to the reset password page for existing users
 */
export function ResetPasswordLink(): ReactElement {
    return (
        <AuthLinkButton href='/u/forgot_password'>
            {translate({ namespace: 'login', key: 'login.atom_reset_password_existing_user' })}
        </AuthLinkButton>
    );
}
